module.exports = "//static.hsappstatic.net/marketplace-ui-solutions-core/static-1.3065/img/solutions-provider-icon-bordered.svg"